import { forwardRef } from "react";
import PropTypes from "prop-types";
import { FormControl, FormHelperText } from "@mui/material";

const SignInInput = forwardRef(
  (
    {
      label,
      id,
      error,
      helperText,
      icon,
      ...inputProps
    },
    ref
  ) => {
    const cleanInputProps = { ...inputProps };
    delete cleanInputProps.fullWidth;
    delete cleanInputProps.size;
    delete cleanInputProps.variant;

    return (
      <div className="login-field">
        <label className="login-field-label" htmlFor={id}>
          {label}
        </label>
        <div className={`login-input-control${error ? " is-error" : ""}`}>
          <input
            {...cleanInputProps}
            ref={ref}
            id={id}
            aria-invalid={error}
          />
          {icon?.component && (
            <span className="login-input-icon">{icon.component}</span>
          )}
        </div>
        {error && helperText && (
          <FormControl error>
            <FormHelperText>{helperText}</FormHelperText>
          </FormControl>
        )}
      </div>
    );
  }
);

SignInInput.displayName = "SignInInput";

SignInInput.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  icon: PropTypes.shape({
    component: PropTypes.node,
    direction: PropTypes.oneOf(["left", "right"]),
  }),
};

SignInInput.defaultProps = {
  error: false,
  helperText: "",
};

export default SignInInput;
